var map = {
	"./accomodation.svg": "3RKf",
	"./activity.svg": "IpTi",
	"./culture.svg": "L16j",
	"./destination.svg": "EecD",
	"./dining.svg": "8KKo",
	"./guide.svg": "m095",
	"./nature.svg": "GNba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Dzyp";